import { CognitoUser } from 'amazon-cognito-identity-js';

export const getEmailFromUser = (user: CognitoUser | any) => {
    return user.user.signInUserSession.idToken.payload.email;
};
